import { Component, Input, OnInit } from '@angular/core';

import { Account } from '@libs/src/models/account.model';

import get from 'lodash-es/get';
import isEqual from 'lodash-es/isEqual';

@Component({
  selector: 'app-feed-item-account-info',
  templateUrl: './feed-item-account-info.component.html',
})
export class FeedItemAccountInfoComponent implements OnInit {
  @Input()
  account: any;
  @Input()
  user: Account;
  isUser: boolean;

  ngOnInit() {
    const accountId = get(this.account, '_id');
    const userId = get(this.user, '_id');
    this.isUser = isEqual(accountId, userId);
  }
}
